export const mapFieldLabels = (fieldLabelsJson = {}) => {
    return Object.keys(fieldLabelsJson).reduce((mappings, fieldName) => {
        const label = fieldLabelsJson[fieldName]?.label;
        if (label) {
            mappings[fieldName] = label;
        }
        return mappings;
    }, {});
};
